export const OPTIMIZE_BANNER_COPY = {
  label: 'Ready to optimize',
  sidePanelLabel: 'What will happen',
  title: 'Reclaim performance, capacity and cost across this cluster',
  description:
    'With the Cast AI agent, workloads can be scaled and what-not. Choose a profile to scale your assets across this cluster.',
  installPrefix: 'Start optimizing to:',
  unlockFeatures: [
    { label: 'Right-size automatically', icon: 'Repeat' as const },
    { label: 'Avoid downtime', icon: 'CloudArrowDown' as const },
    { label: 'Cut idle spend', icon: 'CurrencyDollarSimple' as const },
  ],
  steps: [
    {
      title: 'Rightsize requests',
      description: 'Workloads scaled to observed CPU and memory',
    },
    {
      title: 'Eliminate resource waste',
      description: 'Idle capacity reclaimed continuously',
    },
    {
      title: 'Bin-pack onto fewer nodes',
      description:
        'Pods are consolidated so underutilized nodes can be removed.',
    },
    {
      title: 'Pick more efficient nodes',
      description:
        'Right-priced instance families and sizes are chosen automatically.',
    },
  ],
  cta: 'Optimize now',
} as const;
